import { useMediaQuery, useTheme } from '@mui/material';
export default function useAppBarHeight() {
    var _a = useTheme(), toolbar = _a.mixins.toolbar, breakpoints = _a.breakpoints;
    var toolbarDesktopQuery = breakpoints.up('sm');
    var toolbarLandscapeQuery = "".concat(breakpoints.up('xs'), " and (orientation: landscape)");
    var isDesktop = useMediaQuery(toolbarDesktopQuery);
    var isLandscape = useMediaQuery(toolbarLandscapeQuery);
    var currentToolbarMinHeight;
    if (isDesktop) {
        currentToolbarMinHeight = toolbar[toolbarDesktopQuery];
    }
    else if (isLandscape) {
        currentToolbarMinHeight = toolbar[toolbarLandscapeQuery];
    }
    else {
        currentToolbarMinHeight = toolbar;
    }
    return currentToolbarMinHeight.minHeight;
}
